/**
 * The number Paynow prompts (InGo ADR 0050): the server's `PaynowPhone`,
 * twinned so the app can say "Paynow cannot ask that number" before anything
 * is booked. Paynow takes EcoCash and OneMoney only: Econet's 077 and 078 are
 * EcoCash, NetOne's 071 is OneMoney; any other number, 073 included, is
 * refused, never guessed. The server judges again: this only saves the client
 * a round trip.
 */

/** Each wallet Paynow prompts, by the two digits after the country code. */
const WALLETS = { 71: 'OneMoney', 77: 'EcoCash', 78: 'EcoCash' };

/** The server's words for a number Paynow cannot prompt. */
export const NOT_MOBILE_MONEY = 'Type the number that pays: an EcoCash number, starting 077 or 078, or a OneMoney number, starting 071. Other numbers cannot be asked to pay.';

/** The server's words for a client without an email: Paynow's prompt needs one. Neither names Paynow (Rio, 12 Oct 2026). */
export const EMAIL_NEEDED = 'Add an email address in your profile to pay this way, or choose another way to pay.';

/** The number as it is kept, `2637XXXXXXXX`, or null when Paynow cannot prompt it. */
export function paynowNumber(typed) {
  const digits = String(typed ?? '').replace(/\D/g, '');
  let full;
  if (digits.startsWith('263')) full = digits;
  else if (digits.startsWith('0')) full = `263${digits.slice(1)}`;
  else full = `263${digits}`;

  return /^2637\d{8}$/.test(full) && WALLETS[full.slice(3, 5)] ? full : null;
}

/**
 * The wallet a number pays from, "EcoCash" or "OneMoney": from a number as
 * typed, as kept, or as the server masks it ("0712 ••• 345").
 */
export function paynowWallet(number) {
  const digits = String(number ?? '').replace(/\D/g, '');
  let local;
  if (digits.startsWith('263')) local = digits.slice(3, 5);
  else if (digits.startsWith('0')) local = digits.slice(1, 3);
  else local = digits.slice(0, 2);

  return WALLETS[local] || null;
}
